import React from 'react'
import { Link } from 'react-router-dom'

import Water from '../../static/images/expertise/water-tap.jpg'

const Cardss = (props) => {
  return (
    <div className='home-cardss'>
      <div className='container'>
        <div className='row gx-5'>
          <div
            className='col-lg-6 cardss-water'
            data-aos='fade-down'
            data-aos-delay='600'
          >
            <i class='bi bi-droplet'></i>
            <div className='head'>Water Management</div>
            <p>
              Integrated Water Solutions starting from source to house
              connection.
            </p>
            <Link to='/expertise'>Read More</Link>
          </div>

          <div
            className='col-lg-6 cardss-waste'
            data-aos='fade-down'
            data-aos-delay='700'
          >
            <i class='bi bi-droplet-half'></i>
            <div className='head'>WasteWater Management</div>
            <p>
              Integrated WW solutions starting with collection from dwelling
              units to discharge/recycling.
            </p>
            <Link to='/expertise'>Read More</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Cardss
